export const cleanUrl = () => {
  if (window.location.hash !== '') {
    window.history.replaceState('', document.title, window.location.origin);
  }
};

export const cleanUrlWithDelay = (delay = 500) => {
  setTimeout(cleanUrl, delay);
};
